import { computed, Injectable, inject } from '@angular/core';
import { ai as AiGen, challenge as ChallengeGen } from '@valvur/shared-grpc';
import { CourseSettingsData } from '../../../models';
import { CourseService } from '../../../services/course.service';
import type { CourseCreatorBridge } from './course-creator-bridge.token';

/**
 * Admin Content (VALVUR catalog) host: JSON create, same task/media APIs as school.
 * School FormData create throws if mis-wired.
 */
@Injectable()
export class AdminValvurCourseCreatorBridge implements CourseCreatorBridge {
  #course = inject(CourseService);

  readonly isPublishPending = computed(() =>
    this.#course.publishCourse.isPending(),
  );

  createSchoolDraft(_payload: CourseSettingsData): void {
    throw new Error(
      'AdminValvurCourseCreatorBridge: school FormData create is not available in this host.',
    );
  }

  createAdminValvurDraft(payload: CourseSettingsData): void {
    this.#course.createValvurCourse.mutate(payload);
  }

  publishCourse(courseId: string): Promise<ChallengeGen.Course> {
    return this.#course.publishCourse.mutateAsync(courseId);
  }

  generateVideo(dto: AiGen.GenerateVideoRequestDto): Promise<ChallengeGen.Task> {
    return this.#course.generateVideo.mutateAsync(dto);
  }

  generateAudio(dto: AiGen.GenerateAudioRequestDto): Promise<ChallengeGen.Task> {
    return this.#course.generateAudio.mutateAsync(dto);
  }
}
